import styled from '@xstyled/styled-components';
import Image from '@/UI/Image';

const ColorBoxContainer = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  span:last-of-type {
    text-align: center;
    font-size: xxsmall;
    color: gray-200;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
`;

const ImageBox = styled.span`
  padding: 0.1rem;
  border: ${({ selected }) =>
    selected ? '1px solid #6F758B' : '1px solid transparent'};
  border-radius: 5px;
  overflow: hidden;
`;

export default function ColorBox({ image, color, selected, onClick }) {
  return (
    <ColorBoxContainer
      role="button"
      aria-label="Select product colorway"
      onClick={onClick}
    >
      <ImageBox selected={selected}>
        <Image src={image?.url} alt={image?.label} width={64} height={64} />
      </ImageBox>
      <span>{color}</span>
    </ColorBoxContainer>
  );
}
